<template>
  <div id="app">
    <topcontent v-if="!mobileView" />
    <MobileTopbar v-if="mobileView" />
    <Topbar v-if="!mobileView" />
    <Socialmedia v-if="!mobileView" />
  </div>
</template>

<script>
import Topbar from './components/Topbar.vue'
import MobileTopbar from './components/MobileTopbar.vue'
import Topcontent from './components/Topcontent.vue'
import Socialmedia from './components/Socialmedia.vue'

export default {
  data: () => {
    return {
      mobileView: true
    }
  },
  methods: {
    handleView () {
      this.mobileView = window.innerWidth <= 500
    }
  },
  components: {
    Topbar,
    MobileTopbar,
    Topcontent,
    Socialmedia
  },
  created () {
    this.handleView()
    window.addEventListener('resize', this.handleView)
  }
}

</script>

<style lang="scss">
@import "assets/common.scss";
@import url("https://use.fontawesome.com/releases/v5.9.0/css/all.css");
@import "~vue-directive-tooltip/dist/vueDirectiveTooltip.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $content-colour;
}
button {
  cursor: pointer;
}

button:hover {
  border: 1px solid #000;
}

input:focus, textarea:focus, button:focus {
  outline: none;
  box-shadow: none;
}
.vue-tooltip.tooltip-custom {
  background-color: $media-colour;
  animation: seconds 1.0s forwards;
  animation-delay: 2s;
}

.vue-tooltip.tooltip-custom .tooltip-arrow {
  border-color: $media-colour;
  animation: seconds 1.0s forwards;
  animation-delay: 2s;
}

@keyframes seconds {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    // left: -9999px;
  }
}

</style>
